import ApiService from "@/api.service";

export const CLEAR_CACHE = "/admin/system/clearCache";



const state = {

};

const getters = {

};

const actions = {
    [CLEAR_CACHE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${CLEAR_CACHE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {

};

export default {
    state,
    actions,
    mutations,
    getters
};